import Axios from "axios";
import { 
    apiClient
} from "./APIService";

export const payTrackByCredit = (id) => {
    return apiClient.put(`/track/${id}/pay`, {},{
        headers: {
            "x-access-token": localStorage.getItem('jwt')
        },
    })
}

export const getTrackById = (id) => {
    return apiClient.get(`/track/${id}`,{
        headers: {
            "x-access-token": localStorage.getItem('jwt')
        },
    })
}

export const getReferenceFiles = async (trackID) => {
    return apiClient.get("/refsteminfo/" + trackID, {
        headers: { "x-access-token": localStorage.getItem("jwt") },
      });
}

export const getTrackFiles = (trackID) => {
    return apiClient.get("/steminfo/" + trackID, {
        headers: { "x-access-token": localStorage.getItem("jwt") },
      });
}

export const getFinalStem = (trackID) => {
    return apiClient.get("/finalStemByTrackId/" + trackID, {
        headers: { "x-access-token": localStorage.getItem("jwt") },
      });
}

export const getFinalMix = (trackID) => {
    return apiClient.get("/finishedTracksByTrackId/" + trackID, {
        headers: { "x-access-token": localStorage.getItem("jwt") },
      });
}